import "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/core-js/modules/es.array.iterator.js";
import "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/core-js/modules/es.promise.js";
import "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/core-js/modules/es.object.assign.js";
import "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/core-js/modules/es.promise.finally.js";
// import Vue from 'vue'
// const Vue = require('vue')
import App from './App.vue';
import u8Admin from '@/plugin/u8admin';
import store from './store';
import router from './router';
import { frameInRoutes } from './router/routes';
Vue.use(u8Admin);
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  },
  created: function created() {// TODO::
  },
  mounted: function mounted() {
    this.$store.dispatch('u8sdk/account/load');
    this.$store.commit('u8sdk/release/versionShow'); // this.$store.dispatch('u8sdk/menu/fetchMenus')
  }
}).$mount('#app');